/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */

const setAlertName = ({ fundsAreVerified, plaidAchMismatch, plaidIsValid }) => {
  if(fundsAreVerified){
    return null;
  }

  if (!fundsAreVerified && plaidIsValid) {
    return 'insufficientFunds';
  }

  if (plaidAchMismatch) {
    return 'wrongAccountNumber';
  }

  return null;
};

export const setDashboardModuleStatus = (newStatus = {}) => {
  const statusCssClass = newStatus?.actionIsRequired
    ? 'actionRequired'
    : newStatus?.isComplete
    ? 'complete'
    : newStatus?.isDisabled
    ? 'disabled'
    : 'pending';

  return {
    actionRequiredName: null,
    actionIsRequired: false,
    isComplete: false,
    isDisabled: false,
    statusCssClass,
    ...newStatus
  };
};

const getVerificationsStatus = verifications => {
  const actionRequiredName = setAlertName(verifications);
  const actionIsRequired = !!actionRequiredName;

  return setDashboardModuleStatus({
    actionRequiredName,
    actionIsRequired,
    isComplete:
      (!actionIsRequired && verifications.fundsAreVerified) ||
      !verifications.fundsVerificationRequired,
  });
};

export const getVerificationsFromPayload = payload => {
  const { customerIsGreen, documentsVerificationIsComplete, fundsVerification: fv } = payload;
  const { customerHasPlaid } = fv;

  const verifications = {
    canAttachPlaid: fv.isRequired && !customerHasPlaid,
    fundsAreVerified: customerIsGreen || (fv.isRequired && fv.isCompleted),
    fundsVerificationRequired: fv.isRequired,
    plaidIsValid: fv.isPlaidValidForFundsVerification,
    plaidAchMismatch: customerHasPlaid && !fv.plaidContainsAchAccount,
    plaidInvalidIdentity: customerHasPlaid && !fv.plaidIdentityValidForFunds,
    fundsDeadlineUtc: fv.fundsDeadlineUtc,
    accountNumberMask: fv.accountNumberMask,
  };

  return {
    ...verifications,
    status: getVerificationsStatus(verifications),
    documentsStatusFromVerifications: getDocumentsStatus(
      customerIsGreen,
      documentsVerificationIsComplete
    ),
  };
};

const getDocumentsStatus = (customerIsGreen, documentsVerificationIsComplete) => {
  const isVerified = documentsVerificationIsComplete || customerIsGreen;

  return setDashboardModuleStatus({
    isComplete: isVerified,
  });
};

